export default "<alert type=\"md-local\">\r\n  <strong>Well done!</strong> You successfully read this important alert message.\r\n</alert>\r\n";